import React, { FunctionComponent, useEffect, useRef } from "react";
import { useFormContext } from "react-hook-form";
import {
  TextField as BaseInput,
  Typography,
  InputAdornment,
} from "@mui/material";

export const Input = ({
  id = "",
  name,
  autoFocus = false,
  type = "text",
  variant = "",
  readOnly = false,
  autoMargin = true,
  autoShrink,
  endadornment = null,
  ...props
}) => {
  const {
    register,
    formState: { errors },
  } = useFormContext();
  const inputRef = useRef(null);

  useEffect(() => {
    if (autoFocus && inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  return (
    <>
      <BaseInput
        InputProps={{
          endadornment: endadornment,
        }}
        variant={variant || "standard"}
        inputRef={(e) => {
          register(e);
          inputRef.current = e;
        }}
        inputProps={{
          readOnly: readOnly,
          endadornment: endadornment,
        }}
        InputLabelProps={{
          shrink: autoShrink,
        }}
        type={type}
        name={name}
        style={{ width: "100%", margin: "0.6rem 0rem" }}
        {...props}
      />
      {errors[name] && (
        <Typography style={{ color: "red" }} variant="subtitle2">
          {errors[name].message}
        </Typography>
      )}
    </>
  );
};
